import React from "react";
import { Formik, useFormikContext } from "formik";
import { Button, CircularProgress, Grid, TextField } from "@material-ui/core";
import PageDomain from "../../../domain";
import AppModal from "../../../../../modals/app-modal";
import { emailValidator } from "../../../../../../../methods/emailValidator";

const EmailInputModal = ({ showModal, closeModal }) => {
  const { values: filterValues } = useFormikContext();

  const onClickExportButton = (values, actions) => {
    PageDomain.exportResultsToEmail({
      values,
      actions,
      filterValues,
      closeModal,
    });
  };

  return (
    <AppModal
      title="Enter Email"
      visibility={showModal}
      handleClose={closeModal}
      showActionButtons={false}
    >
      <Grid container className="ad-overview-export-email-modal pb-16">
        <Formik initialValues={{}} onSubmit={onClickExportButton}>
          {({ handleChange, values, handleSubmit, isSubmitting }) => (
            <Grid container direction="column" className="gap-y-16">
              <TextField
                name="email"
                label="Email"
                variant="outlined"
                size="small"
                className="w-full"
                onChange={handleChange}
              />
              <Grid container justifyContent="flex-end" className="gap-x-16">
                <Button onClick={closeModal}>Close</Button>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  className="send-email-button"
                  disabled={!emailValidator(values.email ?? "") || isSubmitting}
                  {...(isSubmitting && {
                    startIcon: (
                      <CircularProgress size={15} className="color-white" />
                    ),
                  })}
                >
                  Send
                </Button>
              </Grid>
            </Grid>
          )}
        </Formik>
      </Grid>
    </AppModal>
  );
};

export default EmailInputModal;
